import React, { useEffect, useState } from 'react';
import Nav from 'react-bootstrap/Nav'
import NavBar from '../components/NavBar'
import { Icon } from 'react-icons-kit'
import { iosPeople } from 'react-icons-kit/ionicons/iosPeople'
import { iosPerson } from 'react-icons-kit/ionicons/iosPerson'
import { ic_work } from 'react-icons-kit/md/ic_work'
import { documentInverted } from 'react-icons-kit/entypo/documentInverted'
import {blocked} from 'react-icons-kit/icomoon/blocked'
import Slide from '@material-ui/core/Slide';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { coinDollar } from 'react-icons-kit/icomoon/coinDollar'
import {creditCardAlt} from 'react-icons-kit/fa/creditCardAlt'
import {bank} from 'react-icons-kit/fa/bank'
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import Tooltip from '@material-ui/core/Tooltip';
import UserOptions from '../components/UserOptions'
import './styles/Home.css';
import FooterDelphus from '../components/FooterDelphus';
import { document } from 'react-icons-kit/iconic/document'
import { dollar } from 'react-icons-kit/iconic/dollar'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Home(props) {
  const [auth, setAuth] = useState(JSON.parse(localStorage['authsalute'] || JSON.stringify({ authenticated: false, user: 0 })));
  const [atalhos, setAtalhos] = useState([
    {
      label: 'Clientes',
      icon: iosPeople,
      path: '/clientes'
    },
    {
      label: 'Contratos',
      icon: documentInverted,
      path: '/contratos',
      size: 32
    },
    {
      label: 'Dependentes',
      icon: iosPerson,
      path: '/dependentes'
    },
    {
      label: 'Contratos Empresas',
      icon: documentInverted,
      path: '/contratos_empresas',
      size: 32
    },
    {
      label: 'Empresas',
      icon: ic_work,
      path: '/empresas'
    },
    {
      label: 'Contas a Receber',
      icon: coinDollar,
      path: '/contas_receber'
    },
    {
      label: 'Débito em Conta',
      icon: dollar,
      path: '/debito_conta',
      size: 32
    },
    {
      label: 'Boletos',
      icon: document,
      path: '/boletos',
      size: 32
    },
    {
      label: 'Cobrança Cartões',
      icon: creditCardAlt,
      path: '/cartoes',
      size: 32
    },
    {
      label: 'Cancelamento Contrato',
      icon: blocked,
      path: '/cancelamento_contrato',
      size: 32
    },
    {
      label: 'Contas',
      icon: bank,
      path: '/contas',
      size: 32
    },


  ])

  return (
    <div className="Home">
      <NavBar />
      <div className="HomeContent">
        <div className="defaultHeader">
          <h3>Seja bem vindo(a), <strong>{auth.name}.</strong></h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="atalhos">

          {atalhos.map(atalho => {
            return (
              <Tooltip title="Segure Ctrl para abrir em nova aba">
                <Nav.Link href={"/salute" + atalho.path} className="atalho">
                  <div className='iconeAtalho'>
                    <Icon icon={atalho.icon} size={atalho.size || 40} />
                    <strong>{atalho.label}</strong>

                  </div>
                </Nav.Link>
              </Tooltip>)
          })}


        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Home;
